import { giphyBlack } from '@giphy/js-brand'
import styled, { css } from 'styled-components'
import ControlSize, { controlBorderRadius, controlHeight } from '../../../types/control-size'
import { brightnessFromColor } from '../../../utils/color/brightness'
import LabelComponent from './label'
import StepperComponent from './stepper'

export const Container = styled.div<{ arrowColor: string; controlSize: ControlSize; disabled: boolean }>`
    background: ${({ arrowColor }) => arrowColor};
    border-radius: ${({ controlSize }) => controlBorderRadius(controlSize)}px;
    color: #fff;
    display: inline-flex;
    height: ${({ controlSize }) => controlHeight(controlSize)}px;

    ${({ disabled }) =>
        disabled &&
        css`
            opacity: 0.5;
            pointer-events: none;
            user-select: none;
        `}
`

export const Label = styled(LabelComponent)<{ controlColor: string }>`
    background: ${({ controlColor }) => controlColor};
    border-radius: inherit;
    color: ${({ controlColor }) => (brightnessFromColor(controlColor) > 0.5 ? giphyBlack : '#fff')};
    height: 100%;
    width: 100%;
`

export const Stepper = styled(StepperComponent)`
    color: inherit;
    height: 100%;
    flex-shrink: 0;
`
